import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const unixToDate = (timestamp: any) =>
    new Date(timestamp * 1000).toLocaleDateString("en-GB");